import { MDBSelect } from 'mdb-react-ui-kit'
import React from 'react'

function ListsSelector() {
  return (
    <MDBSelect
        data={[
        { text: '--Select Lists --', value: 1 },
        { text: 'Two', value: 2 },
        { text: 'Three', value: 3 },
        { text: 'Four', value: 4 },
        { text: 'Five', value: 5 },
        { text: 'Six', value: 6 },
        { text: 'Seven', value: 7 },
        { text: 'Eight', value: 8 },
        ]}
    />
  )
}

export default ListsSelector;